import { EducationClassesTable } from 'widgets/education-classes-table';
import { AppPage } from 'common/Layout';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';

const breadcrumbs = [
  homeBreadcrumbItem,
  {
    title: 'Классы',
    url: '',
  },
];

export const EducationClassesPage = () => {
  return (
    <AppPage breadcrumbs={{ items: breadcrumbs }} documentTitle="Классы">
      <EducationClassesTable />
    </AppPage>
  );
};
